import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_PLACEMENTS } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const placements = {
  namespaced: true,
  state: buildInitialState({
    placementList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setPlacements: (state, placements) => {
      state.placementList = placements
    }
  },
  actions: {
    getPlacements: ({ commit, dispatch, rootState }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting placements, please wait...' })

      const {
        placementTypeId,
        onlyFinalizedContracts,
        dealStatusId,
        businessEntityId,
        clientId,
        consultantId,
        consultantName
      } = rootState.placementFilters

      const parameters = {}
      if (placementTypeId) parameters.placementTypeId = placementTypeId
      if (onlyFinalizedContracts) parameters.onlyFinalizedContracts = onlyFinalizedContracts
      if (dealStatusId) parameters.dealStatusId = dealStatusId
      if (businessEntityId) parameters.businessEntityId = businessEntityId
      if (clientId) parameters.clientId = clientId
      if (consultantId) parameters.consultantId = consultantId
      if (consultantName) parameters.consultantName = consultantName

      return api.doGet({ path: PATH_PLACEMENTS, parameters })
        .then(json => json.data)
        .then(placements => {
          commit('updateStatus', { status: COMPLETE })
          commit('setPlacements', placements)
          return placements
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get placements')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default placements
